import React, { useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

const MachineLearning = () => {
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const handleShow = (url) => {
    setVideoUrl(url);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoUrl("");
  };

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: ¿Por qué un ingeniero debe aprender ML?",
      url: `${videoBaseURL}ML1.mp4`,
      conceptoclave: [
        'El ML como un "filtro" que aprende de ejemplos (datos) en lugar de ecuaciones (reglas programadas).',
      ],
      termino: [
        'Filtro digital tradicional vs. Filtro basado en ML.'
      ]
    },
    {
      nombre: "Video 2: Aprendizaje Supervisado vs. No Supervisado",
      url: `${videoBaseURL}ML2.mp4`,
      conceptoclave: [
        'La diferencia fundamental entre aprender con un "manual de respuestas" (etiquetas) y aprender sin él.',
      ],
      termino: [
        'Datos etiquetados (Supervisado) vs. Datos crudos (No Supervisado).'
      ]
    },
    {
      nombre: "Video 3: El Poder del ML Supervisado (Regresión y Clasificación)",
      url: `${videoBaseURL}ML3.mp4`,
      conceptoclave: [
        'Las dos tareas principales cuando sí tienes etiquetas.',
      ],
      termino: [
        'Regresión (predecir un número, ej. "latencia en ms") y Clasificación (predecir una categoría, ej. "tráfico de voz").'
      ]
    },
    {
      nombre: "Video 4: El Poder del ML No Supervisado (Clustering y Detección de Anomalías)",
      url: `${videoBaseURL}ML4.mp4`,
      conceptoclave: [
        'Las dos tareas principales cuando no tienes etiquetas.',
      ],
      termino: [
        'Clustering (encontrar grupos naturales, ej. "segmentar antenas") y Detección de Anomalías (encontrar al "bicho raro", ej. "alerta de AIOps").'
      ]
    },
    {
      nombre: "Video 5: Deep Learning (Cuando el ML Clásico no es Suficiente)",
      url: `${videoBaseURL}ML5.mp4`,
      conceptoclave: [
        'Cuándo usar Redes Neuronales (Deep Learning) vs. ML Clásico.',
      ],
      termino: [
        'Datos Estructurados (tablas, ML clásico) vs. Datos No Estructurados (señales de RF, imágenes, audio).'
      ]
    },
    {
      nombre: "Video 6: El Proceso de ML de un Ingeniero",
      url: `${videoBaseURL}ML6.mp4`,
      conceptoclave: [
        'El flujo de trabajo de 5 pasos para construir un modelo en el mundo real.',
      ],
      termino: [
        'Adquisición, Limpieza, Ingeniería de Características (Features), Entrenamiento/Prueba e Implementación.'
      ]
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="text-center">
          <h1 className="mt-4">Machine Learning</h1>
          <hr className="linea-horizontal" />
        </div>

        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Título del Video</th>
                <th>Concepto Clave</th>
                <th>Analogía/Términos</th>
                <th>Reproducir</th>
              </tr>
            </thead>

            <tbody>
              {videos.map((video, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td><b>{video.nombre}</b></td>
                  <td>
                    <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                      {video.conceptoclave.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>
                  <td>
                    <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                      {video.termino.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>
                  <td>
                    <Button
                      className="boton"
                      variant="primary"
                      onClick={() => handleShow(video.url)}
                    >
                      Reproducir Video
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>

      {/* Modal para reproducir video */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Reproducción de Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default MachineLearning;
